// Banner shown inside VoiceConfirmModal: prompts user to auto-create accounts
// for unresolved hints extracted by the AI (e.g. "ADIB" when no ADIB exists).
import { useState } from "react";
import { toast } from "sonner";
import { Plus, Landmark } from "lucide-react";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

export function AccountHintBanner({ items, onItemsUpdate }) {
  const { t, lang } = useI18n();
  const [busy, setBusy] = useState(null);
  const hints = [...new Set(items.filter((i) => i.account_hint && !i.account_id).map((i) => i.account_hint))];
  if (hints.length === 0) return null;

  const create = async (hint) => {
    setBusy(hint);
    try {
      const { data } = await api.post("/accounts/ensure", { hint });
      const aid = data.account.id;
      onItemsUpdate(items.map((it) => (it.account_hint === hint ? { ...it, account_id: aid, account_hint: null } : it)));
      toast.success(lang === "ar" ? `تم إنشاء "${data.account.name}" 🏦` : `Created "${data.account.name}" 🏦`);
    } catch { toast.error(t("error")); }
    finally { setBusy(null); }
  };

  const skip = (hint) => onItemsUpdate(items.map((it) => (it.account_hint === hint ? { ...it, account_hint: null } : it)));

  return (
    <div className="mx-6 mb-3 p-3 rounded-2xl bg-blue-50/60 border border-blue-200/60 space-y-2" data-testid="hint-banner">
      <p className="text-xs font-bold text-blue-900/80">
        {lang === "ar" ? "الذكاء الاصطناعي وجد حسابات مذكورة، هل تنشئها؟" : "AI mentioned these accounts — create them?"}
      </p>
      {hints.map((h) => (
        <div key={h} className="flex items-center gap-2 bg-white/70 rounded-xl p-2">
          <Landmark className="w-4 h-4 text-blue-900" />
          <span className="flex-1 font-semibold text-sm text-blue-900">{h}</span>
          <button data-testid={`hint-skip-${h}`} onClick={() => skip(h)} className="px-3 h-8 rounded-lg text-xs font-semibold text-slate-500">
            {lang === "ar" ? "تخطّي" : "Skip"}
          </button>
          <button data-testid={`hint-create-${h}`} onClick={() => create(h)} disabled={busy === h}
            className="px-3 h-8 rounded-lg text-xs font-bold bg-blue-900 text-white flex items-center gap-1 disabled:opacity-60">
            <Plus className="w-3 h-3" />{lang === "ar" ? "إنشاء وربط" : "Create & link"}
          </button>
        </div>
      ))}
    </div>
  );
}
